import { ApiResponse } from 'apisauce'

import i18n from 'src/config/i18n'

export default function findBasicApiResponseErrors(
  response: ApiResponse<any>
): string {
  const { data, problem, status } = response

  if (problem === 'TIMEOUT_ERROR') {
    return i18n.t('common.response.timeout-error')
  }

  if (!status || problem === 'NETWORK_ERROR') {
    return i18n.t('common.response.network-error')
  }

  if (status === 401 && data?.reasons === 'EXPIRED_JWT_SIGNATURE') {
    return i18n.t('common.response.expired-jwt-signature')
  }

  if (status === 403 && data?.exception === 'AccessDenied') {
    if (typeof data.reasons === 'string') {
      return data.reasons
    }
    return i18n.t('common.response.unexpected-error')
  }

  if (status === 500 && typeof data === 'string') {
    try {
      const mathSignature = data.indexOf('InvalidSignatureError')
      if (mathSignature > -1) {
        return i18n.t('common.response.invalid-signature')
      }
    } catch (error) {
      return i18n.t('common.response.unexpected-error')
    }
  }

  if (status === 500) {
    return i18n.t('common.response.status-500')
  }

  return i18n.t('common.response.unexpected-error')
}
